import { SensorConversions } from "../conversionFunctions/sensorConversions.js";
import { OUTPUT_POSITION_RANGE, OutputPosition } from "../outputPosition.js";
import { SensorElementConfig } from "./types.js";

/**
 * Whether a device output is currently energized — an {@link OutputPosition} enum member.
 *
 * Replaces the old `valveState` element, which stored a device-wide bitfield packing both valves' open
 * and automating flags plus the manual-override flag into one value. That could not describe a single
 * output honestly — on a two-valve device each port's stream carried the other port's bits — and it was
 * not aggregatable. A plain 0/1 per output is, so averaging over a window gives the fraction of time
 * that output was active.
 *
 * Operating mode moved to its own sub-channel; see `outputOperatingModeSensorElement`.
 */
export const outputPositionElementConfig: SensorElementConfig<Record<string, never>, typeof SensorConversions.unity> = {
    legalConvertedRange: OUTPUT_POSITION_RANGE,
    conversionKey: "unity",
    parameterConfigs: {},
    buildConversionParams: () => ({}) as Record<string, never>,
    decodedUnits: "dimensionless",
    convertedUnits: "dimensionless",
    unitCategory: "outputPosition",
    testCases: [
        { parameters: {}, decodedValue: OutputPosition.OFF, convertedValue: OutputPosition.OFF },
        { parameters: {}, decodedValue: OutputPosition.ON, convertedValue: OutputPosition.ON },
    ],
};
